import styled from "styled-components";


export const SalePageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    //height: 100%;
    width: 100%;
    padding-top: 2rem;
    margin-bottom: 2rem;
    ${({ theme }) => theme.mediaWidth.upToLarge`
        padding: 0 2rem;
        padding-top: 2rem;
    `}

`;

export const SaleHeaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 270px;
    width: 60%;

    ${({ theme }) => theme.mediaWidth.upToLarge`
        width: 100%;
    `}
`;

export const SaleHeaderContent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding: 2rem;
    //min-height: calc(100% - 76px);
    background-color: ${({ theme }) => theme.newBg1};
    // background-image: url({HeaderBG});
    // background-size: cover;
    // background-position: center;
    // background-repeat: no-repeat;
    border-radius: 0.5rem 0.5rem 0 0;
    ${({ theme }) => theme.mediaWidth.upToMedium`
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
    `}
`;

export const SaleImage = styled.div`
    height: 150px;
    width: 150px;
    z-index: 1;
    background-color: ${({ theme }) => theme.newBg2};
    border-radius: 50%;
    margin-right: 1rem;
    box-shadow: 0px 5px 8px 0px rgba(0,0,0,0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    ${({ theme }) => theme.mediaWidth.upToMedium`
        align-self: center;
    `}
    
    > img {
        width: 150px;
        height: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
        object-fit: cover;
    }
`;

export const SaleInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 60%;
    color: #fff;

    ${({ theme }) => theme.mediaWidth.upToMedium`
        width: 100%;
        font-size: 0.8rem;
    `}

`;

export const SaleTitle = styled.div`
    font-size: 1.5rem;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 1rem 0;
    width: 100%;
    display: flex;
    align-items: center;
    svg {
        width: 1.5rem;
        margin-right: 0.5rem;
        fill: rgb(32, 129, 226);
    }
`

export const SaleSocial = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-end;
    padding: 1rem;
    height: 230px;
`;

export const SaleSocialItem = styled.a`
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    border-radius: 10px;
    margin-right: 10px;
    background-color: #fff;
    color: ${({ theme }) => theme.newBg1};
    &:hover {
        box-shadow: ${({ theme }) => theme.boxShadow};
        transform: translateY(-5px);
        transition: all 0.3s ease-in-out;
        cursor: pointer;
    }
`;


export const SaleMintSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 0 0 0.5rem 0.5rem;
    transition: max-height 0.2s linear;
    box-shadow: 0px 5px 8px 0px rgba(0,0,0,0.3);
    background-color: ${({ theme }) => theme.newBg2};
    //margin-top: 2rem;
    padding: 1rem;
    width: 60%;
    flex: 1;

    ${({ theme }) => theme.mediaWidth.upToLarge`
        width: 100%;
    `}

    > * {
        margin-bottom: 1rem;
    }

`;

export const SaleMintPrice = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const SaleDetails = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    //width: 50%;
`;

export const SaleDetailItem = styled.div`
    display: flex;
    align-items: center;
    margin-top: 1rem;

    > div {
        margin-right: 0.5rem;
        font-size: 1rem;
        font-weight: bold;
    }
`;

export const SalePageCards = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
    position: relative;
    min-height: 550px;
    width: 100%;
    overflow: hidden;
    &:first-child {
        margin-right: 0.5rem;
    }
    &:last-child {
        margin-left: 0.5rem;
    }
`;